import { Link } from "react-router-dom";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/uiDir/card";
import { Avatar, AvatarImage } from "@/components/uiDir/avatar";
import { Badge } from "@/components/uiDir/badge";
import { Button } from "@/components/uiDir/button";
import { Flame, ArrowRight, FolderOpen, Heart } from "lucide-react";
import { TrendingProject } from "@/lib/models/dashboardmodels";

interface TrendingProjectsProps {
  projects: TrendingProject[];
}

export const TrendingProjects = ({ projects }: TrendingProjectsProps) => {
  return (
    <Card className="border-0 shadow-lg">
      <CardHeader>
        <div className="flex items-center justify-between">
          <CardTitle className="text-lg flex items-center gap-2">
            <Flame className="h-5 w-5 text-orange-500" />
            Trending on Campus
          </CardTitle>
          <Link to="/discover/projects">
            <Button variant="ghost" size="sm">
              Explore
              <ArrowRight className="h-4 w-4 ml-1" />
            </Button>
          </Link>
        </div>
      </CardHeader>
      <CardContent>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          {projects.slice(0, 4).map((project) => (
            <Link key={project.id} to={`/profile/${project.user.username}`}>
              <Card className="border-0 shadow hover:shadow-lg transition-all hover:-translate-y-1 overflow-hidden group">
                <div className="relative h-32 bg-gradient-to-br from-gray-100 to-gray-200">
                  {project.cover_image ? (
                    <img src={project.cover_image} alt={project.title} className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-300" />
                  ) : (
                    <div className="w-full h-full flex items-center justify-center"><FolderOpen className="h-10 w-10 text-gray-400" /></div>
                  )}
                  <div className="absolute top-2 right-2 bg-black/70 text-white text-xs px-2 py-1 rounded-full flex items-center gap-1"><Heart className="h-3 w-3 fill-current" />{project.likes_count}</div>
                </div>
                <CardContent className="p-3">
                  <p className="font-semibold text-sm line-clamp-1 mb-1">{project.title}</p>
                  <div className="flex items-center gap-2 mb-2">
                    <Avatar className="h-4 w-4"><AvatarImage src={project.user.avatar_url || `https://api.dicebear.com/7.x/avataaars/svg?seed=${project.user.username}`} /></Avatar>
                    <p className="text-xs text-gray-600 truncate">@{project.user.username}</p>
                  </div>
                  {project.tags && project.tags.length > 0 && (
                    <div className="flex gap-1">{(project.tags || []).slice(0, 2).map((tag, i) => (<Badge key={i} variant="secondary" className="text-xs">{tag}</Badge>))}</div>
                  )}
                </CardContent>
              </Card>
            </Link>
          ))}
        </div>
      </CardContent>
    </Card>
  );
};